import { HttpWebtrack } from 'utility/http';
import { ConfigActions } from 'utility/http/http-events';
import configureInterceptors from 'utility/http/interceptors/configure-interceptors';
import { store } from '@redux/storeConfig/store';

const baseUrl = '/unit';

export interface UnitAssignedHub {
  geofenceId: number;
  geofenceName: string;
  privateCode: string | null;
  isPrimary: boolean;
}

export interface SaveHubAssignmentsRequest {
  unitId: number;
  hubs: { geofenceId: number; isPrimary: number }[];
}

export const getUnitAssignedHubsService = (
  request: { unitId: number },
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'hubs.hub',
    action: 'Get',
    genderType: 'PluralMale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/assignedHubs`, request);
};

export const saveUnitHubAssignmentsService = (
  request: SaveHubAssignmentsRequest,
  configActions: ConfigActions
) => {
  const httpWebtrack = new HttpWebtrack();
  configureInterceptors.ConfigureWebtrackInterceptor(store, httpWebtrack);
  httpWebtrack.setConfigMessage({
    object: 'hubs.hub',
    action: 'Edit',
    genderType: 'PluralMale'
  });
  httpWebtrack.setConfigActions(configActions);
  return httpWebtrack.post(`${baseUrl}/saveHubAssignments`, request);
};
